import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ACCENTS = ['#FF553B', '#4CDCE6', '#D0FF3F', '#F5C846'];

export const Packages = () => {
  const { t } = useTranslation();
  const items = t('packages.items', { returnObjects: true }) || [];

  return (
    <section id="packages" className="relative border-b border-ink py-20 md:py-28" data-testid="packages">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        <div className="flex items-center gap-3 mb-8">
          <span className="font-mono text-xs bg-ink text-page px-2 py-1 tracking-widest2">§ 05</span>
          <span className="font-mono uppercase text-xs tracking-widest2 text-ink">{t('packages.eyebrow')}</span>
        </div>

        <div className="grid grid-cols-12 gap-8 md:gap-12 mb-12 md:mb-16">
          <div className="col-span-12 lg:col-span-7">
            <h2 className="display text-6xl md:text-7xl lg:text-8xl leading-[0.9] text-ink">
              {t('packages.h1_pre')}<br />
              <span className="serif-italic">{t('packages.h1_italic')}</span>{' '}
              <span
                className="inline-block px-2 md:px-3 text-ink"
                style={{ background: '#F5C846' }}
              >
                {t('packages.h1_hl')}
              </span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:pt-6">
            <p className="serif-italic text-xl md:text-2xl leading-snug text-ink/85">
              {t('packages.lede')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {items.map((pkg, i) => {
            const accent = ACCENTS[i % ACCENTS.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.6, delay: (i % 2) * 0.1 }}
                className="box-line p-6 md:p-8 flex flex-col hover:-translate-y-1 transition-transform duration-500"
                data-testid={`package-card-${i}`}
              >
                <div className="flex items-start justify-between mb-6">
                  <span className="display text-5xl md:text-6xl text-ink leading-none">0{i + 1}</span>
                  <span className="w-6 h-6" style={{ background: accent, border: '1px solid #0B0B0B' }} />
                </div>
                <h3 className="font-mono uppercase text-base md:text-lg font-medium text-ink mb-2">
                  {pkg.name}
                </h3>
                <p className="font-mono uppercase text-[10px] tracking-widest2 text-ink/60 mb-4">
                  {pkg.tag}
                </p>
                <p className="serif-italic text-base md:text-lg text-ink/80 leading-snug mb-6">
                  {pkg.blurb}
                </p>
                <ul className="space-y-1.5 mb-6 flex-1">
                  {(pkg.bullets || []).map((b, bi) => (
                    <li key={bi} className="font-mono text-xs md:text-[13px] text-ink/90 flex gap-2">
                      <span aria-hidden className="shrink-0" style={{ color: accent }}>▸</span>
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  className="dash-divider pt-4 inline-flex items-center justify-between text-ink group"
                  data-testid={`package-cta-${i}`}
                >
                  <span className="font-mono uppercase text-xs tracking-widest text-ink group-hover:text-clay transition-colors">
                    {pkg.cta || t('packages.defaultCta')}
                  </span>
                  <span aria-hidden className="font-mono">↗</span>
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
